import React from 'react';
import './Spinner.css';

const spinner = () => {
  return (
    <div className="Loader">Loading...</div>
  )
}

export default spinner;